import React, { useState, useEffect } from 'react';

// 예시
function useWindowWidth(): number {
  const [width, setWidth] = useState(window.innerWidth);
  const delay = 300;
  let timer;

  useEffect(() => {
    function onResize() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        setWidth(window.innerWidth);
      }, delay);
    }

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return width;
}

export default useWindowWidth;
